import isUndefined from 'lodash/isUndefined';

const prepareUrlForMatching = (plainUrl) => {
    let [ url ] = plainUrl.split('?');
    if (url !== '/' && url.endsWith('/')) {
        // just because of eslint... ;]
        const beginSlice = 0;
        const endSlice = -1;
        url = url.slice(beginSlice, endSlice);
    }

    return url;
};

/**
 * This method is reponsible for finding campaignId which matches to current url.
 * Campaings associated to urls are stored in the json file.
 * @see CAMPAIGNS_JSON_URL
 * @param {Object} placeholders  Placeholders to urls mappings
 * @param {string} url           Url for which we'll try to find matching placeholderId
 *
 * There are two types of matching ordered by priority:
 *     1) Exact matching
 *     2) Pattern matching
 *
 * (1) "EXACT MATCHING"
 *     Firstly, we are checking if is there any key in JSON which matches
 *     to current url.
 *     If it's there we return associated campaignId.
 *     If not, we proceed to PATTERN MATCHING
 *
 * (2) "PATTERN MATCHING"
 *     Secondly, we need to check, if is there any key that matches the url.
 *     As you can see in the example JSON at the top of this file,
 *     there are some keys which contain '*' for some segments.
 *     They mean basically "any value in this segment".
 *
 *     Golden rule of Pattern Matching:
 *         We are looking for a pattern which has
 *         exact same amount of segments as current url.
 *
 *     When we look for the best pattern, we replace one segment at the time
 *     and perform the lookup in JSON.
 *     Segments are replaced from the end to the beginning.
 *
 *     There is no business requirement to place '*' at any posotion of pattern.
 *
 * @returns {(Number|null)}   Wheter numeric value of campaign id
 *                            or null
 */
export const lookupPlaceholderIdByUrl = (placeholders, url) => {
    const preparedUrl = prepareUrlForMatching(url);
    let placeholderId = placeholders[preparedUrl];

    if (!isUndefined(placeholderId)) {
        return placeholderId;
    }

    let urlSegments = preparedUrl.split('/');
    const firstSegmentIndex = 0;
    let asteriskPosition = urlSegments.length;

    while (asteriskPosition > firstSegmentIndex) {
        urlSegments.fill('*', asteriskPosition);
        placeholderId = placeholders[urlSegments.join('/')];

        if (!isUndefined(placeholderId)) {
            return placeholderId;
        }

        asteriskPosition--;
    }

    return null;
};
